export const defaultWidth = 350;
export const defaultOpacity = 0.5;
export const defaultDurationMs = 250;
export const defaultDurationS = 0.35;
